import { CallableCreator } from '..';

interface ReserveDepositReq {
	orderId: string;
	shopId: string;
}

type ReserveDepositRes = {
	status: 'success';
};

export const modifications = (createCallable: CallableCreator) => ({
	reserveDeposit: createCallable<ReserveDepositReq, ReserveDepositRes>(
		'orders-modifications-reserveDeposit',
	),
});
